<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card max-width="75%" width="500" flat>
        <v-row class="d-flex">
          <h1 class="mb-4">Forma de pago</h1>
        </v-row>
        <v-row>
          <v-expansion-panels v-model="formOkBoy.panelSelected" @change="clearForm()">
            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate >
                <div>
                  <img src="../assets/card.svg" class="icon" />
                  Pago con tarjeta
                </div>
                <template v-slot:actions>
                  <v-icon v-if="formOkBoy.panelSelected !== 0">
                    mdi-checkbox-blank-circle-outline
                  </v-icon>
                  <v-icon v-if="formOkBoy.panelSelected === 0" color="secondary">
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="background">
                <v-form ref="form">
                  <v-row class="d-flex">
                    <h3 class="mb-4">Información del pago</h3>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="formOkBoy.titularTarjeta"
                      outlined
                      label="Titular de la tarjeta:"
                      placeholder="Nombre del titular"
                      :disabled="pagoTarjetaMaximoFlag"
                      :rules="nameRules"
                      :counter="30"
                      maxlength="30"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="formOkBoy.numeroTarjeta"
                      outlined
                      label="Número de la tarjeta:"
                      placeholder="16 dígitos"
                      :disabled="pagoTarjetaMaximoFlag"
                      :rules="cardNumberRules"
                      :counter="16"
                      maxlength="16"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formOkBoy.validaTarjeta"
                        outlined
                        label="Válida hasta:"
                        placeholder="MM/AA"
                        :disabled="pagoTarjetaMaximoFlag"
                        :rules="mmaaRules"
                        v-mask="'##/##'"
                        maxlength="5"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formOkBoy.cvvTarjeta"
                        outlined
                        label="CVV:"
                        placeholder="***"
                        :disabled="pagoTarjetaMaximoFlag"
                        :rules="cvvRules"
                        :counter="3"
                        maxlength="3"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex">
                    <h3 class="mb-4">Dirección de facturación</h3>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="formOkBoy.calleFacturacion"
                      outlined
                      label="Calle:"
                      placeholder="Nombre de la calle"
                      :rules="streetRules"
                      :counter="30"
                      maxlength="30"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formOkBoy.numExteriorFacturacion"
                        outlined
                        label="Número exterior:"
                        placeholder="0"
                        :rules="numExtRules"
                        maxlength="5"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formOkBoy.codigoPostalFacturacion"
                        outlined
                        label="Código Postal:"
                        placeholder="00000"
                        :rules="postalCodeRules"
                        maxlength="5"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="formOkBoy.estadoFacturacion"
                      outlined
                      label="Estado:"
                      placeholder="Estado"
                      :rules="stateRules"
                      :counter="30"
                      maxlength="30"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="formOkBoy.ciudadFacturacion"
                      outlined
                      label="Ciudad:"
                      placeholder="Ciudad"
                      :rules="cityRules"
                      :counter="30"
                      maxlength="30"
                    ></v-text-field>
                  </v-row>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate>
                <div>
                  <img src="../assets/terminal.svg" class="icon" />
                  Pago con terminal
                </div>
                <template v-slot:actions>
                  <v-icon v-if="formOkBoy.panelSelected !== 1">
                    mdi-checkbox-blank-circle-outline
                  </v-icon>
                  <v-icon v-if="formOkBoy.panelSelected === 1" color="secondary">
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
              </v-expansion-panel-header>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate>
                <div>
                  <img src="../assets/efectivo.svg" class="icon" />
                  Pago en efectivo
                </div>
                <template v-slot:actions>
                  <v-icon v-if="formOkBoy.panelSelected !== 2">
                    mdi-checkbox-blank-circle-outline
                  </v-icon>
                  <v-icon v-if="formOkBoy.panelSelected === 2" color="secondary">
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
              </v-expansion-panel-header>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="secondary" text block @click="back()">Atrás</v-btn>
          </v-col>
          <v-col>
            <v-btn class="buttonPrimary" block @click="next()">Siguiente</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { JSEncrypt } from "jsencrypt";
import pubKey from "./../statics/publicKey";
import { mask } from "vue-the-mask";
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  computed: {
    ...mapFields(["landingCounter", "formOkBoy", "pagoTarjetaMaximoFlag", "showMessage", "message"]),
  },
  directives: {
    mask,
  },
  data() {
    return {
      // panels: 0,
      nameRules: [
        (v) => !!v || "El nombre es requerido.", //
      ],
      cardNumberRules: [
        (v) => !!v || "El número de tarjeta es requerido.", //
        (v) => (v && v.length <= 16) || "El número debe ser de 16 dígitos",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
      mmaaRules: [
        (v) => !!v || "La vigencia es requerida.", //
        (v) => (v && v.length <= 5) || "El número debe ser de 4 dígitos",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
      cvvRules: [
        (v) => !!v || "El cvv es requerido.", //
        (v) => (v && v.length <= 3) || "El número debe ser de 3 dígitos",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
      cityRules: [
        (v) => !!v || "La ciudad es requerida.",
        ],
      stateRules: [
        (v) => !!v || "El estado es requerido.",
        ],
      postalCodeRules: [
        (v) => !!v || "El código postal es requerido.",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
        ],
      numExtRules: [
        (v) => !!v || "El número exterior es requerido.",
        ],
      streetRules: [
        (v) => !!v || "La calle es requerida.",
        ]
    };
  },
  methods: {
    next() {
      if (this.formOkBoy.panelSelected >= 0) {
        switch (this.formOkBoy.panelSelected) {
          case 0:
            this.formOkBoy.formaPago = "Tarjeta";
            if (this.$refs.form.validate()) {
              this.formOkBoy.formaPagoID = 3;
              this.encryptData();
              mixpanel.track('Click Pago Tarjeta');
              this.landingCounter++;
            }
            break;
          case 1:
            this.formOkBoy.formaPago = "Terminal";
            this.formOkBoy.formaPagoID = 2;
            mixpanel.track('Click Pago Terminal');
            this.landingCounter++;
            break;
          case 2:
            this.formOkBoy.formaPago = "Efectivo";
            this.formOkBoy.formaPagoID = 1;
            mixpanel.track('Click Pago Efectivo');
            this.landingCounter++;
            break;
        }
      } else {
        this.message = 'Selecciona un método de pago.'
        this.showMessage = true
      }
    },
    back() {
      this.clearForm();
      this.landingCounter--;
    },
    clearForm() {
      this.$refs.form.reset();
    },
    encryptData() {
      let card = {
        number: "",
        cvv: "",
        name: "",
        expiration: "",
      };
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(pubKey.publicKey);
      card.number = encrypt.encrypt(this.formOkBoy.numeroTarjeta);
      card.cvv = encrypt.encrypt(this.formOkBoy.cvvTarjeta);
      card.name = encrypt.encrypt(this.formOkBoy.titularTarjeta);
      card.expiration = encrypt.encrypt(this.formOkBoy.validaTarjeta);
      this.formOkBoy.cardCrypto = card;
    },
  },
  watch: {
    pagoTarjetaMaximoFlag: function (val) {
      if (val) {
        this.clearForm();
      }
    },
  },
};

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': 'https://okboy.app/pay',
    'pageTitle': 'Payment Service'
  });
</script>

<style scoped>
.theme--light.v-sheet {
  background-color: #f1f3f6;
  border-color: #f1f3f6;
  color: rgba(0, 0, 0, 0.87);
}
.icon {
  width: 28px;
  height: 30px;
  object-fit: contain;
}
</style>